
/*
//============= squiggle underline effect ===================

// Function to create and animate the squiggle underline
function addSquiggleUnderline() {
  const element = document.querySelector('h2#ymm_label');
  console.log('element: ',element);
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("class", "icon icon-squiggle-underline");
  svg.setAttribute("viewBox", "-347 -30.1947 694 96.19");
  svg.setAttribute("stroke", "currentColor");
  svg.setAttribute("fill", "none");
  svg.setAttribute("role", "presentation");
  svg.setAttribute("preserveAspectRatio", "none");
  svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");

  const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
  path.setAttribute("stroke-linecap", "round");
  path.setAttribute("stroke-width", "20");
  path.setAttribute("pathLength", "1");
  path.setAttribute("d", "M-335,54 C-335,54 -171,-58 -194,-3 C-217,52 -224.1199951171875,73.552001953125 -127,11 C-68,-27 -137,50 -33,42 C31.43899917602539,37.042999267578125 147.14700317382812,-29.308000564575195 335,2");
  svg.appendChild(path);

  element.appendChild(svg);

  setInterval(() => {
    svg.classList.toggle('visible');
  }, 5000);
}

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(addSquiggleUnderline, 2000); 
});
*/


// (function() {
  // ======= 1) Inject ALL CSS =======
  const style = document.createElement('style');
  style.textContent = `
  /* Reset & layout */
  #ymm_searchbox { margin: 0 !important; }
  #ymm_label     { margin-bottom: 30px !important; }

  /* Make the container stick to the top */
  #ymm_searchbox_cont {
    position: sticky;
    top: 0;
    z-index: 999;
    background: transparent; /* match your site background */
    backdrop-filter: blur (8px);
    display: flex;
    justify-content: center;
    transition:
      transform 0.4s cubic-bezier(.4,0,.2,1),
      opacity   0.4s ease,
      box-shadow 0.4s ease;
    transform-origin: top center;
    will-change: transform, opacity;
  }

  #ymm_searchbox ul.dropdowns {
    display: flex;
    gap: 12px !important;
  }

  /* Keyframes for dropdowns */
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeOut {
    from { opacity: 1; transform: translateY(0); }
    to   { opacity: 0; transform: translateY(8px); }
  }
  .ymm-filter    { transition: all 0.3s ease; }
  .animated-in   { animation: fadeIn  0.4s ease forwards; }
  .animated-out  { animation: fadeOut 0.3s ease forwards; }

  /* Scrolled‑down (shrunken) */
  #ymm_searchbox_cont.scrolled-down {
    transform: scale(0.85) translateY(-10px);
    opacity: 0.7;
    box-shadow: 0 8px 20px rgba(0,0,0,0.15);
  }
  /* Scrolled‑up (normal) */
  #ymm_searchbox_cont.scrolled-up {
    transform: scale(1) translateY(0);
    opacity: 1;
    box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  }

  /* Mobile tweaks */
  @media (max-width: 600px) {
    #ymm_searchbox_cont.scrolled-down {
      transform: scale(0.9) translateY(-6px);
      opacity: 0.8;
      box-shadow: 0 6px 16px rgba(0,0,0,0.12);
    }
  }
  `;
//   document.head.appendChild(style);

//   // ======= 2) Main Script =======
//   document.addEventListener('DOMContentLoaded', () => {
//     const container = document.getElementById('ymm_searchbox_cont');
//     if (!container) return;

//     // --- Dropdown animation setup ---
//     const dropdowns = [
//       document.getElementById('dropdown-field_1'),
//       document.getElementById('dropdown-2-field_2'),
//       document.getElementById('dropdown-3-field_3'),
//       document.getElementById('dropdown-4-field_4'),
//     ].filter(Boolean);

//     dropdowns[0]?.classList.add('animated-in');
//     dropdowns.forEach((dd, idx) => {
//       dd.addEventListener('change', () => {
//         for (let i = idx + 1; i < dropdowns.length; i++) {
//           const nxt = dropdowns[i];
//           nxt.value = '-1';
//           nxt.disabled = true;
//           nxt.classList.replace('animated-in','animated-out');
//         }
//         const next = dropdowns[idx + 1];
//         if (next && !next.disabled) {
//           next.classList.replace('animated-out','animated-in');
//         }
//       });
//     });

//     document.addEventListener('shopify:section:load', e => {
//       if (e.detail.sectionId === 'template--24909111197977__ymm_FX3thJ') {
//         dropdowns[0]?.classList.add('animated-in');
//       }
//     });

//     // --- Scroll‑direction logic ---
//     let lastY = window.scrollY;
//     // start in the “up” state
//     container.classList.add('scrolled-up');

//     window.addEventListener('scroll', () => {
//       const currentY = window.scrollY;
//       if (currentY > lastY) {
//         // scrolling down
//         container.classList.add('scrolled-down');
//         container.classList.remove('scrolled-up');
//       } else {
//         // scrolling up or at top
//         container.classList.add('scrolled-up');
//         container.classList.remove('scrolled-down');
//       }
//       lastY = currentY;
//     }, { passive: true });
//   });
// })();





